import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import {
    IAddRemarkCode,
    IEditRemarkCodeResponse,
} from "../types/remark-codes.types";
import {
    addRemarkCode,
    deleteRemarkCode,
    editRemarkCode,
} from "../services/remark-codes.services";

export function useAddRemarkCodes() {
    return useMutation<
        IApiResponse<IEditRemarkCodeResponse>,
        AxiosError<IApiResponse<IEditRemarkCodeResponse>>,
        IAddRemarkCode
    >({
        mutationKey: ["add-remark-code"],
        mutationFn: (payload: IAddRemarkCode) => addRemarkCode(payload),
    });
}

export function useEditRemarkCodes(remitId: string) {
    return useMutation<
        IApiResponse<IEditRemarkCodeResponse>,
        AxiosError<IApiResponse<IEditRemarkCodeResponse>>,
        IAddRemarkCode
    >({
        mutationKey: ["edit-remark-code"],
        mutationFn: (payload: IAddRemarkCode) =>
            editRemarkCode(remitId, payload),
    });
}

export function useDeleteRemarkCode(codeId: string) {
    return useMutation<
        IApiResponse<{ message: string }>,
        AxiosError<IApiResponse<{ message: string }>>,
        null
    >({
        mutationKey: ["delete-remark-code"],
        mutationFn: () => deleteRemarkCode(codeId),
    });
}
